import LoginForm from './components/LoginForm';
export default function DeveloperLoginPage() {
  return <LoginForm role="developer" />;
}
